import baseDiscoverService from './base/baseDiscoverService.js';

const createAiDiscoverabilityAssessment = (payload, config) => {
    return baseDiscoverService.post("api/reports/full-assessment", payload, config);
};
const getAiDiscoverabilityReport = (id, config) => {
    return baseDiscoverService.get(`api/reports/${id}`, config);
};
const getAiDiscoverabilityReports = (config) => {
    return baseDiscoverService.get(`api/reports`, config);
};

export { createAiDiscoverabilityAssessment, getAiDiscoverabilityReport, getAiDiscoverabilityReports };
